import { getCdn } from "utils";

const SocialMediaIcon = ({ className, title = "", src, loading = "lazy" }) => {
	if (src) {
		const imageSrc =
			src.indexOf("http") === 0 ? src : `${getCdn(true)}/icons/${src}`;
		return (
			<img
				src={imageSrc}
				alt={title}
				title={title}
				className={`syndicated-social-icon ${className}`}
				loading={loading}
			/>
		);
	} else {
		return null;
	}
};
export default SocialMediaIcon;
